import { Native } from '../../utils/native/native';
import { CoreAuthNativeProvider } from './native-provider/CoreAuthNative.provider';
import { CoreAuthProviderProps } from './types';
import { CoreAuthWebProvider } from './web-provider/web-provider';

const CoreAuthProvider = (props: CoreAuthProviderProps) => {
  if (Native.WebView) {
    return <CoreAuthNativeProvider {...props} />;
  }
  return <CoreAuthWebProvider {...props} />;
};

export { CoreAuthProvider };
